import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function HeroSection() {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative pt-16 md:pt-8 pb-12 md:pb-20 px-6 min-h-[70vh] md:min-h-screen flex items-center overflow-hidden">
      {/* Sky Blue Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#4B91DE] to-[#95C7F6]"></div>
      
      {/* Fog/Mist Effect at Bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-96">
        {/* Multiple layers for realistic fog effect */}
        <div className="absolute inset-0 bg-gradient-to-t from-white via-white/90 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gray-50/80 via-transparent to-transparent"></div>
        
        {/* Animated fog layers */}
        <div className="absolute inset-0 opacity-60">
          <div className="absolute bottom-0 left-0 right-0 h-64 bg-gradient-to-t from-white/95 via-white/40 to-transparent animate-pulse"></div>
        </div>
        
        {/* Subtle cloud shapes using radial gradients */}
        <div className="absolute bottom-0 left-1/4 w-96 h-48 bg-white/30 rounded-full blur-3xl transform -translate-x-1/2"></div>
        <div className="absolute bottom-0 right-1/4 w-80 h-40 bg-white/40 rounded-full blur-3xl transform translate-x-1/2"></div>
        <div className="absolute bottom-10 left-1/2 w-72 h-32 bg-white/35 rounded-full blur-2xl transform -translate-x-1/2"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto text-center w-full px-4">
        <h2 className="text-4xl md:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight drop-shadow-lg">
          LinkedIn without Limits
        </h2>
        <p className="text-base md:text-2xl text-white/95 mb-8 md:mb-10 max-w-3xl mx-auto drop-shadow-md">
           Collect all the information you need, follow the latest trends, and write top-quality posts, all without being stuck to your own network.
        </p>
        <button onClick={() => scrollToSection('waitlist')} className="bg-white text-gray-900 px-6 md:px-10 py-3 md:py-4 rounded-xl text-base md:text-lg hover:bg-gray-50 transition-all transform hover:scale-105 shadow-2xl flex items-center gap-2 md:gap-3 mx-auto font-semibold cursor-pointer">
          Get Started
          <ArrowRight className="w-4 h-4 md:w-5 md:h-5" />
        </button>
      </div>
      
      {/* Decorative elements - floating subtle clouds */}
      <div className="absolute top-20 left-10 w-32 h-16 bg-white/20 rounded-full blur-xl"></div>
      <div className="absolute top-40 right-20 w-40 h-20 bg-white/15 rounded-full blur-xl"></div>
      <div className="absolute top-60 left-1/3 w-24 h-12 bg-white/25 rounded-full blur-lg"></div>
    </section>
  );
}